export const ACCESS_TOKEN = "admin_access_token";